import React from "react";
import PropTypes from "prop-types";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";
import { useSelector } from "react-redux";
import { setActivetabData } from "../../../utils/middleware/adminProptechTab";
import { dispatch } from "../../../../utils/utility/store";
import { Actions } from "../../../../store/actions";
import { adminProptechForYouTabs } from "../../../constants";
import AdminConnectHomeTab from "./connect";
import AdminPlaceHomeTab from "./place";
import AdminRFFHomeTab from "./rff";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

export default function AdminProptechHomeTab() {
  const { activeTabIndex, selectedProptech, activeHomeTabIndex } = useSelector(
    (state) => state.adminUser
  );
  const adminDropdowns = useSelector((state) => state.adminDropdowns);
  const adminAnalysisTab = useSelector((state) => state.adminAnalysisTab);

  const handleChange = (event, newValue) => {
    dispatch(Actions.AdminUser.SetProptechHomeActiveTabIndex, newValue);
    setActivetabData(
      activeTabIndex,
      selectedProptech?.id,
      adminAnalysisTab,
      adminDropdowns,
      0,
      0,
      newValue
    );
  };

  return (
    <>
      <Box sx={{ width: "100%", paddingBottom: "60px" }}>
        <Box
          sx={{
            borderBottom: 1,
            borderColor: "divider",
            position: "sticky",
            top: 0,
          }}
          className="bg-white z-10"
        >
          <Tabs
            value={activeHomeTabIndex}
            onChange={handleChange}
            aria-label="tabs"
            variant="scrollable"
          >
            {adminProptechForYouTabs.length !== 0 &&
              adminProptechForYouTabs.map((item, index) => (
                <Tab label={item.name} {...a11yProps(index)} key={item.id} />
              ))}
          </Tabs>
        </Box>

        <TabPanel value={activeHomeTabIndex} index={0}>
          <AdminConnectHomeTab />
        </TabPanel>

        <TabPanel value={activeHomeTabIndex} index={1}>
          <AdminPlaceHomeTab />
        </TabPanel>

        <TabPanel value={activeHomeTabIndex} index={2}>
          <AdminRFFHomeTab />
        </TabPanel>
      </Box>
    </>
  );
}
